import { environment } from "#environments/environment";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class PrimaveraService {
  constructor(private http: HttpClient) {}

  getProjects(
    user?: string,
    instanceName?: string
  ): Observable<Array<{ [key: number]: string }>> {
    const params = {};

    if (user) params["user"] = user;
    if (instanceName) params["instanceName"] = instanceName;

    return this.http.get<Array<{ [key: number]: string }>>(
      `${environment.apiEndpoint}/primavera/projects`,
      { params }
    );
  }

  getWbsObjects(
    projectId: number,
    instanceName?: string
  ): Observable<Array<{ [key: number]: string }>> {
    const params = {};

    if (instanceName) params["instanceName"] = instanceName;

    return this.http.get<Array<{ [key: number]: string }>>(
      `${environment.apiEndpoint}/primavera/projects/${projectId}/wbs`,
      { params }
    );
  }
}
